import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HeroSectionB } from '../components/HeroSectionB';
import { SignalSection } from '../components/SignalSection';
import { SymptomsSection } from '../components/SymptomsSection';
import { AnticipationSection } from '../components/AnticipationSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { QuizSection } from '../components/QuizSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
const getVariant = (): string => {
  if (typeof window === 'undefined') return 'a';
  return new URLSearchParams(window.location.search).get('v') ?? 'a';
};
export function LandingPage() {
  const variant = getVariant();
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-415" data-mp="3davcnd5gslot">

      {/* Concepto 2: Señal con reveal secuencial */}
      <SignalSection data-id="element-416" data-mp="3i957fmna1k9w" />

      {/* Espejo emocional — justo después de "tu cuerpo no falló" */}
      <SymptomsSection data-id="element-417" data-mp="3n6ojqh0ezmz7" />

      {/* Test A/B: solo el hero cambia */}
      {variant === 'b' ? <HeroSectionB data-id="element-418" data-mp="3ramjmtxkd1tb" /> : <HeroSection data-id="element-419" data-mp="3r80cgvel4obm" />}

      {/* Concepto 4: Protocolo con journey bar + fases interactivas */}
      <ProtocolSection data-id="element-420" data-mp="30jhba1zhh7" />

      {/* Quiz H.E.R. — descubrí qué fase conecta más con vos */}
      <QuizSection data-id="element-421" data-mp="1wxwoy9zdfokv" />

      {/* Concepto 3: Anticipación — el destino antes del vehículo */}
      <AnticipationSection data-id="element-422" data-mp="21voqlvptip29" />

      <BenefitsSection data-id="element-423" data-mp="21wzudvj9jwtd" />
      <PainSection data-id="element-424" data-mp="355kfwvd2uk1i" />
      <TestimonialsSection data-id="element-425" data-mp="3573xqqedt35e" />
      <ForWhoSection data-id="element-426" data-mp="356ce8dy26vvh" />
      <BibliotecaSection data-id="element-427" data-mp="357x61vszo0pn" />

      {/* Antes/Después + cierre de identidad — justo antes del CTA */}
      <DifferenceSection data-id="element-428" data-mp="309c3hpq9l4y1" />

      <OfferSection data-id="element-429" data-mp="3e7a8w5mlxr1e" />
      <AboutSection data-id="element-430" data-mp="3e7jyhs3qpw6k" />
      <FAQSection data-id="element-431" data-mp="3e823bd4gxiq3" />
      <FinalCTASection data-id="element-432" data-mp="3e4ea6f2xqybw" />

    </main>;
}